import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KeyValidationService } from '../../services/key-validation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Header } from '../header/header.model';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SupportingDocumentDetails } from '../../models/supporting-documents-claim-detail.model';
import { HeaderService } from '../header/header.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import * as moment from 'moment';
import { UUID } from 'angular2-uuid';
import { SupportingDocumentService } from '../../services/supportingDocument.service';

@Component({
  selector: 'app-supporting-documents-claim-detail',
  templateUrl: './supporting-documents-claim-detail.component.html',
  styleUrls: ['./supporting-documents-claim-detail.component.scss']
})
export class SupportingDocumentsClaimDetailComponent implements OnInit {
  registerForm: UntypedFormGroup;
  headerData: Header = new Header();
  labelCaption: any;
  supportingDocumentDetails = new SupportingDocumentDetails();
  description: any ;
  adjudicationId:any;
  userId:any;
  isSupportingDocumentIdEmpty:boolean;
  isLoading:boolean = true;
  public Editor = ClassicEditor;
  public config = {
    height:'200px',
    placeholder: 'Type the content here!',
    toolbar: [
    ],
    link: {
      decorators: {
        addTargetToExternalLinks: {
          mode: 'automatic',
          callback: url => /^(https?:)?\/\//.test(url),
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        }
      },
      defaultProtocol: 'http://'
    }
  }
  constructor(private formBuilder: UntypedFormBuilder, private spinnerService: NgxSpinnerService, private supportingDocumentService: SupportingDocumentService,
    private keyValidationService: KeyValidationService, private utilitiesService: UtilitiesService, private activatedRoute: ActivatedRoute, private router:Router) {
    this.spinnerService.show();
  }


  ngOnInit(): void {
    let data = this.utilitiesService.GetLabelCaption(
      this.activatedRoute.snapshot.data.labelCaptionData,
      'Module_supporting-documents-claim-detail'
    );
    if (data && data['Label']) {
      this.labelCaption = data['Label'];
    }
    this.registerForm = this.formBuilder.group({
      description: ['', [Validators.required]]
    });
    this.userId = sessionStorage.getItem('userId');

    this.activatedRoute.paramMap.subscribe(params => {
      this.adjudicationId = params.get('adjudicationId');
      this.isSupportingDocumentIdEmpty = params.get('isSupportingDocumentIdEmpty') == "true";
      this.supportingDocumentDetails.supportingDocumentId= params.get('supportingDocumentId');
    });

    if(!this.supportingDocumentDetails.supportingDocumentId){
      this.supportingDocumentDetails.supportingDocumentId=UUID.UUID();
    }
    //Get Claim Details
    this.supportingDocumentService.getSupportingDocumentClaimDetails(this.adjudicationId, this.supportingDocumentDetails?.supportingDocumentId, this.isSupportingDocumentIdEmpty,this.userId)
      .subscribe((response:any) => {
        if(response.hasPermissiontoView){
          this.spinnerService.hide();
        if (response) {
          this.isLoading = false;
          this.supportingDocumentDetails = response;
          this.supportingDocumentDetails.podReceivedDate = this.supportingDocumentDetails.podReceivedDate ? "" + moment(this.supportingDocumentDetails.podReceivedDate).format('DD-MMM-yyyy') : null;
          this.supportingDocumentDetails.dateSent = this.supportingDocumentDetails.dateSent ? "" + moment(this.supportingDocumentDetails.dateSent).format('DD-MMM-yyyy') : null;
        }
        }
        else{
          this.spinnerService.hide();
        this.router.navigate(['creditorhome']);
        }
        
      });

  }
  disableDescriptionField() {
    this.registerForm.controls?.description.disable();
  }
  closeTab() {
    window.top.close();
  }

}

